import React, { useState, useEffect } from 'react';
import './Customers.css';
import { Row, Col, Input } from 'reactstrap';
import axios from 'axios';
import { var_api, image_api } from '../constant';
import Swal from 'sweetalert2';
import Layout from '../NewHeader/Layout';
import DefaultProfileImage from '../../images/profile.png';
import Pagination from 'react-js-pagination';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';



const Customers = () => {
  const [customers, setCustomers] = useState([]); 
  const [filteredCustomers, setFilteredCustomers] = useState([]); // State to store filtered customer data
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);   
  const itemsPerPage = 10; 
  const [searchQuery, setSearchQuery] = useState(''); // Search query state
  const history = useHistory();


  // Fetch customer data on component mount
  useEffect(() => {
    fetchCustomers();
  }, [currentPage]);

  // Function to fetch customers from the API
  const fetchCustomers = async () => {
      // Retrieve the token from localStorage or other storage method
      const token = localStorage.getItem('Token'); // Replace with the appropriate method to get your token
      const shop_id=localStorage.getItem('ShopId');
      const startIndexCalc = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndexCalc + itemsPerPage;
    try {
      const response = await axios.get(`${var_api}customers/get-with-credits/${shop_id}`, {
        headers: {
          Authorization: `${token}`,  // Pass the token in the Authorization header
        }
      });
      const customersList = response.data;
      setCustomers(customersList || []);  // Assuming the response has a 'customers' field
      setTotalItems(customersList.length);
      setStartIndex(startIndexCalc);
      setFilteredCustomers(customersList.slice(startIndexCalc, endIndex) || []);  // Initialize filtered customers with the full list
      console.log("count", response.data.totalCount )
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      Swal.fire('Error', 'Failed to fetch customer data', 'error');
      setTotalItems(0);
      setStartIndex(0);
    }
  };

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

   // Function to handle search input change and filter the customers
   const handleSearchInput = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    
    if (query === '') {
      setFilteredCustomers(customers); // Reset to original customers list if search is empty
    } else {
      // Filter customers by search query (you can adjust this for different fields)
      const filtered = customers.filter((customer) => 
        customer.customer_name && customer.customer_name.toLowerCase().includes(query.toLowerCase()) || 
        customer.mobile_no && customer.mobile_no.toLowerCase().includes(query.toLowerCase()) ||
        customer.country && customer.country.toLowerCase().includes(query.toLowerCase()) ||
        customer.address && customer.address.toLowerCase().includes(query.toLowerCase()) ||
        customer.city && customer.city.toLowerCase().includes(query.toLowerCase()) ||
        customer.state && customer.state.toLowerCase().includes(query.toLowerCase()) ||
        customer.email_id && customer.email_id.toLowerCase().includes(query.toLowerCase()) ||
        (customer.credit_limit && customer.credit_limit.toString().toLowerCase().includes(query.toLowerCase())) || // Convert to string
      (customer.due_date && customer.due_date.toString().toLowerCase().includes(query.toLowerCase())) ||// Convert to string
      (customer.pincode && customer.pincode.toString().toLowerCase().includes(query.toLowerCase())) || // Convert pincode to string
      (customer.approval_status !== undefined &&
          (customer.approval_status === 0 ? "Requested credit user" : 
          customer.approval_status === 1 ? "Approved credit user" : 
          customer.approval_status === 2 ? "Rejected credit user" : "Not an credit user")
          .toLowerCase().includes(query.toLowerCase())) || // Search in approval_status
      (customer.rejected_remarks && customer.rejected_remarks.toLowerCase().includes(query.toLowerCase())) // Search in rejected_remarks
  );
      setFilteredCustomers(filtered);
    }
    console.log("cust", filteredCustomers)
  };

  const handleViewClick = (data) => {
    console.log("cust", data);
    history.push({
      pathname: '/customers-orders',
      state: { customer_id: data.id, customer_name: data.customer_name },
    });
  };



  return (
    <Layout>
      <div className="splitno">
        <div
          style={{
            border: 'none',
            padding: '15px',
            width: '100%',
            height: 'auto',
            margin: 'auto',
            borderRadius: '15px',
            backgroundColor: 'white',
            boxShadow:
              ' rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px',
          }}
        >
          <Row>
            <div className="d-flex justify-content-between">
              <div>
                <h4 className="ushe">CUSTOMERS</h4>
              </div>
              <div className="d-flex justify-content-between">
                <div>
                  {/* <Button variant='dark' onClick={handleCredit} style={{fontSize:"14px",borderRadius:"10px", marginLeft:"10px"}}>Create Credit Customer</Button>{' '} */}
                </div>
                <div className="ms-4">
                  <input
                    className="form-control m-0"
                    type="text"
                    placeholder="Search"
                    style={{ width: '100%', float: 'right' }}
                    onChange={handleSearchInput}
                    value={searchQuery} // Bind search value
                  />
                </div>
              </div>
            </div>
          </Row>

          <div className="table-container" style={{ height: 'auto', overflowY: 'auto', marginTop: '10px' }}>
            <table className="table caption-top" style={{ borderColor: 'grey', width: '100%', margin: 'auto' }}>
              <thead>
                <tr style={{ fontWeight: 'bold' }}>
                  <th style={{ textAlign: 'left' }}>S.No</th>
                  <th style={{ textAlign: 'left' }}>Profile</th>
                  <th style={{ textAlign: 'left' }}>Customer Name</th>
                  <th style={{ textAlign: 'left' }}>Mobile</th>
                  <th style={{ textAlign: 'left' }}>Email ID</th>
                  <th style={{ textAlign: 'left' }}>Address</th>
                  <th style={{ textAlign: 'left' }}>City</th>
                  <th style={{ textAlign: 'left' }}>State</th>
                  <th style={{ textAlign: 'left' }}>Country</th>
                  <th style={{ textAlign: 'left' }}>Pincode</th>
                  <th style={{ textAlign: 'left' }}>Is Credit User</th>
                  <th style={{ textAlign: 'left' }}>Credit Limit</th>
                  <th style={{ textAlign: 'left' }}>Due Date</th>
                  <th style={{ textTransform: 'capitalize', textAlign: 'left' }} scope="col">
                    Remarks
                  </th>
                  <th style={{ textAlign: 'left' }}>View Orders</th>
                </tr>
              </thead>
              <tbody className="body-half-screen">
                {filteredCustomers.length > 0 ? (
                  filteredCustomers.map((data, index) => (
                    <tr key={index}>
                      <td>{startIndex + index + 1}</td>
                      <td style={{ textTransform: 'capitalize', textAlign: 'left' }}>
                        <img
                          src={data.profile_image ? `${image_api}/${data.profile_image}` : DefaultProfileImage}
                          alt="profile"
                          style={{ width: '75px', height: '65px', objectFit: 'cover' }}
                        />
                      </td>
                      <td>{data.customer_name || '-'}</td>
                      <td>{data.mobile_no || '-'}</td>
                      <td>{data.email_id || '-'}</td>
                      <td>{data.address || '-'}</td>
                      <td>{data.city || '-'}</td>
                      <td>{data.state || '-'}</td>
                      <td>{data.country || '-'}</td>
                      <td>{data.pincode || '-'}</td>
                      <td>{data.approval_status == 0 ? "Requested credit user" : data.approval_status == 1 ? "Approved credit user" : data.approval_status == 2 ? "Rejected credit user" : "Not an credit user"}</td>
                      <td>${data.credit_limit || '-'}</td>
                      <td>{data.due_date || '-'}</td>
                      <td>{data.rejected_remarks || '-'}</td>
                      <td>
                      <Button variant="primary" size='sm' 
                      onClick={() => handleViewClick(data)}
                     ><i class="bi bi-arrow-right"></i></Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" style={{ textAlign: 'center', color: 'red', fontWeight: 'bold', borderColor: 'black' }}>
                      No Credit Customer Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <Pagination
              activePage={currentPage}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={totalItems}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              itemClass="page-item"
              linkClass="page-link"
              innerClass="pagination justify-content-end mt-4"
              activeClass="active-pagination"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Customers;
